import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AuthState, selectUserInfo, selectUserSubscriptions } from '@emi/shared/state/auth';
import { MenuItem } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { fetchSkuMetadata, getSkuMetadataState, SkuMetadataState } from '@emi/shared/state/sku-metadata';

@Component({
    selector: 'via-header-nav',
    templateUrl: './header-nav.component.html',
    styleUrls: ['./header-nav.component.scss'],
})
export class HeaderNavComponent implements OnInit {
    @Input() menuItems: MenuItem[];

    public userData: any;
    public userSubscriptions: any;
    public hasMultipleSubscriptions: boolean;
    public homeRoute = '/';
    public logoutRoute = Constants.Routes.LOGOUT_ROUTE;
    public aboutEuromonitorRoute = Constants.Routes.ABOUT_EUROMONITOR;

    public navMenuItems: MenuItem[] = [
        {
            name: 'Search',
            url: Constants.Routes.SEARCH_INFO_GRAPHIC,
        },
        {
            name: 'Export',
            url: Constants.Routes.EXPORT_ROUTE,
        }

       /* Insights has benn removed
       {
            name: 'Insights',
            url: Constants.Routes.INSIGHTS_INFO_GRAPHIC,
        },*/
    ];

    public dataUpdatedDateTime: Date | undefined;

    public supportMenuItems: MenuItem[] = [
        {
            name: 'Browser Support',
            url: Constants.Routes.BROWSER_SUPPORT,
        },
        {
            name: 'Contact Us',
            url: Constants.Routes.CONTACT_US,
        },
    ];

    public helpMenuItems: MenuItem[] = [
        {
            name: 'Get Started',
            url: Constants.Routes.GET_STARTED,
        },
        {
            name: 'Video Tutorials',
            url: Constants.Routes.VIDEO_TUTORIALS,
        },
    ];

    public referenceMenuItems: MenuItem[] = [
        {
            name: 'FAQs',
            url: Constants.Routes.FAQ,
        },
        {
            name: 'Definitions',
            url: Constants.Routes.DEFINITIONS,
        },
        // TODO: Hidden for MVP release
        // {
        //     name: 'Methodology',
        //     url: Constants.Routes.METHODOLOGY,
        // },
    ];

    constructor(private authStore: Store<AuthState>, private skuMetadataStore: Store<SkuMetadataState>, private router: Router) {}

    public ngOnInit(): void {
        this.authStore.pipe(select(selectUserInfo)).subscribe((x) => (this.userData = x.userData));
        this.authStore.pipe(select(selectUserSubscriptions)).subscribe((x) => (this.userSubscriptions = x));
        this.skuMetadataStore.dispatch(fetchSkuMetadata());

        this.hasMultipleSubscriptions = this.userSubscriptions.length > 1;

        this.skuMetadataStore.pipe(select(getSkuMetadataState)).subscribe((x) => (this.dataUpdatedDateTime = x.lastUpdated));
    }

    public hasActiveChildRoute(menuItems: MenuItem[]): boolean {
        for (let menuItem of menuItems) {
            if (this.router.url.includes(menuItem.url)) {
                return true;
            }
        }
        return false;
    }

    public navigateTo(url: string, redirect?: boolean): void {
        if (!redirect) {
            this.router.navigateByUrl(url);
        } else {
            window.location.href = url;
        }
    }

    public navigateOut(): void {
        window.location.replace(Constants.ExternalLinks.SUBSCRIPTION_APPS_PAGE);
    }

    public openGuidedHelp(): void {
        // TODO
    }
}
